// extracted by mini-css-extract-plugin
export var errorsContainer = "_rr-1";
export var link = "_rr-0";